import React from 'react';
interface ProgressBarProps {
  current: number;
  total: number;
}
export function ProgressBar({
  current,
  total
}: ProgressBarProps) {
  const percent = Math.round(current / total * 100);
  return <div data-id="element-104" data-mp="iv0icxstx0vv">
      <div className="flex items-baseline justify-between font-sans text-sm text-noche/60" data-id="element-105" data-mp="iwv4ugjr1122">
        <span data-id="element-106" data-mp="dxi89432sfma">
          Pregunta {current} de {total}
        </span>
        <span className="text-dorado-deep" data-id="element-107" data-mp="1amzo2bvrvi1p">{percent}%</span>
      </div>
      <div className="mt-3 h-1 w-full overflow-hidden rounded-full bg-noche/10" role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={current} aria-label="Avance del test" data-id="element-108" data-mp="1akvjdrq1uf0d">
        <div className="h-full rounded-full bg-dorado transition-[width] duration-300 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-109" data-mp="wnzwavcyqn1b" />
      </div>
    </div>;
}